<script lang="ts">
    import { _ } from "svelte-i18n"
    import { onMount } from "svelte"

    import { cart, checkoutData, getAsyncCartSum } from "../../../store"
    import { postPayment } from "../../../api"
    import type { AuthorizationResponse, SessionResponse } from "../../../../../api/hooks/lib/klarna-api"
    import MiniLoader from "../../widgets/MiniLoader.svelte"

    export let submitHandler: () => Promise<void>

    let kContainer: HTMLElement

    let initialized = false
    async function initKlarna() {
        console.log("init klarna")
        postPayment({
            type: "klarna",
            cart: $cart,
            sum: await getAsyncCartSum($cart),
            vat: $checkoutData.vat,
            contact: $checkoutData.contact,
            billingAddress: $checkoutData.billingAddress,
            deliveryAddress: $checkoutData.deliveryAddress,
        })
            .then((p) => {
                let payload = p.payload
                let session: SessionResponse = Array.isArray(payload) ? payload[0] : payload

                initialized = true
                kContainer.innerHTML = ""

                // @ts-ignore
                window.Klarna.Payments.init({
                    client_token: session.client_token,
                })

                // @ts-ignore
                window.Klarna.Payments.load(
                    {
                        container: "#klarna-payments-container",
                    },
                    (res) => {
                        console.log(res)
                    }
                )
            })
            .catch((e) => {
                console.log(e)
                alert($_("klarna.error"))
            })
    }
    let mounted = false
    onMount(() => {
        mounted = true
    })

    // @ts-ignore
    let klarnaScriptLoaded = !!window.Klarna

    // for first load
    // @ts-ignore
    window.klarnaAsyncCallback = initKlarna

    $: if (klarnaScriptLoaded && mounted) {
        // for second+ load
        console.log("second klarna load")
        initKlarna()
    }

    function authorize() {
        // @ts-ignore
        window.Klarna.Payments.authorize(null, null, (res: AuthorizationResponse) => {
            console.log(res)
            if (res.show_form && res.approved && res.authorization_token) {
                $checkoutData.payment.authorization_token = res.authorization_token
                submitHandler()
            } // else klarna will show error in widget
        })
    }
</script>

<svelte:head>
    {#if !klarnaScriptLoaded}
        <script src="https://x.klarnacdn.net/kp/lib/v1/api.js" async></script>
    {/if}
</svelte:head>

<div id="k">
    <h4>{$_("klarna.order_now")}</h4>
    {#if !initialized}<MiniLoader />{/if}
    <div bind:this="{kContainer}" id="klarna-payments-container"></div>
    {#if initialized}
        <div style="text-align: right">
            <button type="button" class="btn btn-secondary" on:click="{authorize}">{$_("klarna.proceed")}</button>
        </div>
    {/if}
</div>

<style>
    #k {
        width: 600px;
        max-width: 100%;
    }
</style>
